var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ods-checkbox-group",class:{'ods-checkbox-group--full-width' : _vm.fullWidth},attrs:{"role":"group","aria-label":"checkbox-group"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }